import { atom } from 'jotai';
import { GridApi } from 'ag-grid-community';
import { SourcingList, SourcingSavedSearch } from '../../../schemas/SourcingList.schema';

export const sourcingTitleEditingAtom = atom<{ isEditing: boolean; initialValue: string }>({
  isEditing: false,
  initialValue: '',
});

export const sourcingGridApiAtom = atom<GridApi | null>(null);

/**
 * Opens the Refresh Settings dialog when non-null; the stored list is both the trigger
 * and the hydration source. Any entry point (sidebar row, page header menu) can set it.
 */
export const refreshSettingsDialogAtom = atom<SourcingList | SourcingSavedSearch | null>(null);
